import { rpc } from '@server/infrastructure/rpc'
import { Destination } from '@server/schemas'

import type { LoginCountry } from '../model/login-country'

type OAuthProvider = 'kakao' | 'apple' | 'line' | 'google'

type GetOAuthAuthorizeUrlParams = {
  provider: OAuthProvider
  destination: Destination
  prompt?: string
  country?: LoginCountry
}

export const getOAuthAuthorizeUrl = ({ provider, destination, prompt, country }: GetOAuthAuthorizeUrlParams): URL => {
  const url = rpc.api.v2.authentication[':provider'].authorize.$url({
    param: {
      provider,
    },
    query: {
      destination,
      prompt,
      country,
    },
  })
  if (destination === 'PURCHASE_FLOW' && typeof window !== 'undefined') {
    const values = new URLSearchParams(window.location.search).getAll('purchase_flow')
    if (values.length === 1) url.searchParams.set('purchase_flow', values[0])
  }
  return url
}
